import FaceList from "./FaceList";
import FaceCreate from "./FaceCreate"
import FaceEdit from "./FaceEdit";

export default {
    list: FaceList,
    create: FaceCreate,
    edit: FaceEdit,
};
